import Controls, { Control, ControlBox } from './styled';

export default Controls;

export { Control, ControlBox };
